import React from "react";
import { useState } from "react";
import { Flex, Heading, HStack, Spacer } from "@chakra-ui/layout";
import {GiHamburgerMenu} from 'react-icons/gi';
import { GrClose } from 'react-icons/gr';
import { Button, IconButton } from "@chakra-ui/button";
import { Link as RouterLink } from "react-router-dom";

function Header() {

  const [display, changeDisplay] = useState('none');

  return(
    <Flex backgroundColor='#19323C' fontFamily="monospace" color="white">
      <Flex 
        padding='8'
        top='1rem'
        left='1rem'
        align='center'
        width='100vw'
      >
        <RouterLink to="/">
          <Heading fontFamily="monospace" fontSize='5xl'>
            eclair
          </Heading>
        </RouterLink>
        <Spacer/>
        <Flex display={['none', 'none', 'flex', 'flex']}>
          <HStack spacing='4'>
            <RouterLink to="/nfts">
              <Button
                as='a'
                fontSize='xl'
                variant='ghost'
                aria-label='explore'
                my={5}
                w='100%'
                rounded="50"
                _hover="false"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                explore
              </Button>
            </RouterLink>

            <RouterLink to="/listings">
              <Button
                as='a'
                variant='ghost'
                aria-label='marketplace'
                fontSize='xl'
                my={5}
                w='100%'
                rounded="50"
                _hover="false"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                marketplace
              </Button>
            </RouterLink>
            <RouterLink to="/mint">
              <Button
                  as='a'
                  variant='ghost'
                  aria-label='mint'
                  fontSize='xl'
                  my={5}
                  w='100%'
                  rounded="50"
                  _hover="false"
                  _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
                >
                  mint
              </Button>
            </RouterLink>

            <RouterLink to="/profile">
              <Button
                as='a'
                variant='ghost'
                aria-label='dashboard'
                fontSize='xl'
                my={5}
                w='100%'
                rounded="50"
                backgroundColor="black"
                _hover="false"
                _focus="none"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                dashboard
              </Button>
            </RouterLink>
          </HStack>
        </Flex>
        <IconButton 
          aria-label='Open menu'
          size='lg'
          mr={2}
          icon={<GiHamburgerMenu color='#19323C'/>}
          display={['flex','flex','none','none']}
          onClick={()=> changeDisplay('flex')}
        />
      </Flex>
      <Flex
        w='100vw'
        backgroundColor='#506269'
        zIndex={20}
        h='100vh'
        pos='fixed'
        top='0'
        left='0'
        display={display}
        alignItems='center'
        justifyContent='center'
        margin='0'
      >
        <Flex
        flexDir='column'
        align ='center'
        >
            <RouterLink to="/nfts">
              <Button
                as='a'
                fontSize='xl'
                variant='ghost'
                aria-label='explore'
                my={5}
                w='100%'
                rounded="50"
                _hover="false"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                explore
              </Button>
            </RouterLink>

            <RouterLink to="/listings">
              <Button
                as='a'
                variant='ghost'
                aria-label='marketplace'
                fontSize='xl'
                my={5}
                w='100%'
                rounded="50"
                _hover="false"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                marketplace
              </Button>
            </RouterLink>
            <RouterLink to="/mint">
              <Button
                  as='a'
                  variant='ghost'
                  aria-label='mint'
                  fontSize='xl'
                  my={5}
                  w='100%'
                  rounded="50"
                  _hover="false"
                  _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
                >
                  mint
              </Button>
            </RouterLink>

            <RouterLink to="/profile">
              <Button
                as='a'
                variant='ghost'
                aria-label='dashboard'
                fontSize='xl'
                my={5}
                w='100%'
                rounded="50"
                backgroundColor="black"
                _hover="false"
                _focus="none"
                _active={{
                  textColor: "black",
                  backgroundColor: "white",
                }}
              >
                dashboard
              </Button>
            </RouterLink>
        </Flex>
        <Flex>
          <IconButton 
            aria-label='Close menu'
            size='lg'
            mr={2}
            mt={2}
            icon={<GrClose/>}
            onClick={()=> changeDisplay('none')}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default Header;